export const LoadingContent = () => {
  return (
    <p className="nj-share--loading">
      <span className="nj-share--progress-icon" />
      <span className="nj-share--loading-title">Creating public link…</span>
    </p>
  );
};
